export default "__VITE_ASSET__77861030__"